@if (isTextPreview) {
<tec-pwcs-layout
	[class.dark]="isDarkMode"
	[title]="'DESIGN.THEME_DETAIL.PREVIEW.TEXT.TITLE' | translate"
	[subtitle]="'DESIGN.THEME_DETAIL.PREVIEW.TEXT.SUBTITLE' | translate"
	[footerLabel]="'DESIGN.THEME_DETAIL.PREVIEW.TEXT.FOOTER' | translate"
>
	<tec-progress [value]="previewProgress" />

	<ng-container content>
		<tec-tile
			type="default"
			styling="default"
			[title]="'DESIGN.THEME_DETAIL.PREVIEW.TEXT.DOCS_TITLE' | translate"
		>
			<p class="preview-text preview-text--secondary">
				{{ 'DESIGN.THEME_DETAIL.PREVIEW.TEXT.DOCS_DESCRIPTION' | translate }}
			</p>
			<div class="collapse-group">
				<tec-collapse
					[title]="'DESIGN.THEME_DETAIL.PREVIEW.COLLAPSE.DOCUMENT_TYPE.DNI' | translate"
					[expanded]="true"
					secondary
				>
					<div class="preview-collapse-body">
						<p class="preview-text preview-text--strong">
							{{ 'DESIGN.THEME_DETAIL.PREVIEW.TEXT.COLLAPSE_BODY' | translate }}
						</p>
					</div>
				</tec-collapse>
				<tec-collapse
					[title]="'DESIGN.THEME_DETAIL.PREVIEW.COLLAPSE.DOCUMENT_TYPE.PASSPORT' | translate"
					[expanded]="true"
					secondary
				>
					<div class="preview-collapse-body">
						<p class="preview-text preview-text--strong">
							{{ 'DESIGN.THEME_DETAIL.PREVIEW.TEXT.COLLAPSE_BODY' | translate }}
						</p>
					</div>
				</tec-collapse>
			</div>
		</tec-tile>
	</ng-container>
</tec-pwcs-layout>
} @else if (isButtonsPreview) {
<tec-pwcs-layout
	[class.dark]="isDarkMode"
	[title]="'DESIGN.THEME_DETAIL.PREVIEW.BUTTONS_SECTION.TITLE' | translate"
>
	<tec-progress [value]="previewProgress" />

	<ng-container content>
		<div class="preview-choose-grid">
			<div class="preview-choose-card">
				<tec-card-access
					[tagImage]="chooseBankTag"
					[title]="'DESIGN.THEME_DETAIL.PREVIEW.BUTTONS_SECTION.OPTION_BANK' | translate"
				/>
			</div>
			<div class="preview-choose-card">
				<tec-card-access
					[tagImage]="chooseIrpfTag"
					[title]="'DESIGN.THEME_DETAIL.PREVIEW.BUTTONS_SECTION.OPTION_IRPF' | translate"
				/>
			</div>
		</div>
	</ng-container>

	<ng-container actions>
		<tec-button
			type="secondary"
			[label]="'DESIGN.THEME_DETAIL.PREVIEW.BUTTONS.BACK' | translate"
			[size]="'lg'"
		/>
		<tec-button
			[label]="'DESIGN.THEME_DETAIL.PREVIEW.BUTTONS.CONTINUE' | translate"
			[size]="'lg'"
		/>
	</ng-container>

	<tec-nav-help [elements]="previewNavHelp" />
</tec-pwcs-layout>
} @else if (isLinksPreview) {
<tec-pwcs-layout
	[class.dark]="isDarkMode"
	[title]="'DESIGN.THEME_DETAIL.PREVIEW.LINKS_SECTION.TITLE' | translate"
>
	<tec-progress [value]="previewProgress" />

	<ng-container content>
		<div class="preview-links-step">
			<div class="preview-links-step__illustration">
				<img
					class="preview-links-doc"
					[src]="linksTutorialImageSrc"
					alt=""
				/>
			</div>
			<tec-link>
				{{ 'DESIGN.THEME_DETAIL.PREVIEW.LINKS_SECTION.HELP_LINK' | translate }}
			</tec-link>
		</div>
	</ng-container>

	<ng-container actions>
		<tec-button
			[label]="'DESIGN.THEME_DETAIL.PREVIEW.LINKS_SECTION.READY' | translate"
			[size]="'lg'"
		/>
	</ng-container>
</tec-pwcs-layout>
} @else if (isLoadingPreview) {
<div class="preview-loading-stack" [class.dark]="isDarkMode">
	<tec-pwcs-layout class="preview-loading-card" [class.dark]="isDarkMode">
		<tec-progress [value]="previewProgress" />
		<ng-container content>
			<div class="preview-loading-spinner">
				<tec-spinner
					[show]="true"
					[opaque]="false"
					[text]="'DESIGN.THEME_DETAIL.PREVIEW.LOADING_SECTION.WAIT' | translate"
					[img]="previewSpinnerSrc || undefined"
				/>
			</div>
		</ng-container>
	</tec-pwcs-layout>

	<tec-pwcs-layout class="preview-loading-card preview-loading-card--scan" [class.dark]="isDarkMode">
		<ng-container content>
			<div class="preview-scan-face">
				<tec-scan-face
					[match]="true"
					[grow]="true"
					[halfLeft]="true"
					[progressValue]="scanFacePreviewProgress"
				>
					<div class="preview-scan-face__camera" aria-hidden="true"></div>
				</tec-scan-face>
			</div>
			<p class="preview-scan-face__hint">
				{{ 'DESIGN.THEME_DETAIL.PREVIEW.LOADING_SECTION.SCAN_HINT' | translate }}
			</p>
		</ng-container>
	</tec-pwcs-layout>
</div>
} @else if (isGraphicsPreview) {
<div class="preview-graphics" [class.dark]="isDarkMode">
	<div class="preview-graphics__tile preview-graphics__tile--life">
		<div class="preview-graphics__asset preview-graphics__asset--pol" [innerHTML]="graphicsPolSvg"></div>
		<p
			class="preview-graphics__life-text"
			[innerHTML]="'DESIGN.THEME_DETAIL.PREVIEW.GRAPHICS_SECTION.LIFE_CHECK' | translate"
		></p>
	</div>

	<div class="preview-graphics__tile preview-graphics__tile--lottie">
		<div class="pwcs-lottie-frame preview-graphics__lottie-frame">
			@if (graphicsLottieOptions) {
				<ng-lottie [options]="graphicsLottieOptions" />
			}
		</div>
	</div>

	<div class="preview-graphics__tile preview-graphics__tile--docs">
		<div class="preview-graphics__asset preview-graphics__asset--docs" [innerHTML]="graphicsDocsSvg"></div>
	</div>
</div>
} @else if (isFieldsPreview) {
<tec-pwcs-layout
	class="preview-fields"
	[class.dark]="isDarkMode"
	[title]="'DESIGN.THEME_DETAIL.PREVIEW.FIELDS_SECTION.TITLE' | translate"
>
	<tec-progress [value]="previewProgress" />

	<ng-container content>
		<div class="preview-fields__form">
			<tec-form-group [label]="'DESIGN.THEME_DETAIL.PREVIEW.FIELDS_SECTION.INCOME_LABEL' | translate">
				<tec-input type="text" [formControl]="fieldsIncomeControl" />
			</tec-form-group>

			<tec-form-group [label]="'DESIGN.THEME_DETAIL.PREVIEW.FIELDS_SECTION.PRODUCTS_LABEL' | translate">
				<tec-toggle
					[options]="fieldsProductOptions"
					[formControl]="fieldsProductsControl"
					[multiple]="true"
				/>
			</tec-form-group>

			<tec-form-group [label]="'DESIGN.THEME_DETAIL.PREVIEW.FIELDS_SECTION.PLAN_LABEL' | translate">
				<div class="preview-fields__select">
					<tec-select
						[options]="fieldsPlanOptions"
						[formControl]="fieldsPlanControl"
						[isOpen]="true"
					/>
				</div>
			</tec-form-group>
		</div>
	</ng-container>
</tec-pwcs-layout>
} @else if (isAdvancedPreview) {
<tec-pwcs-layout
	class="preview-advanced"
	[class.dark]="isDarkMode"
	[title]="'DESIGN.THEME_DETAIL.PREVIEW.ADVANCED_SECTION.TITLE' | translate"
>
	<tec-topnav
		[img]="previewLogo"
		[title]="themeData?.show_product_name ? 'Identity' : ''"
	>
		<div class="preview-topnav-lang">
			<tec-select [options]="languageOptions" [formControl]="languageControl" />
		</div>
	</tec-topnav>

	<tec-progress [value]="previewProgress" />

	<ng-container content>
		<div class="preview-advanced__body">
			<tec-tile
				[icon]="'icon-file'"
				[title]="'DESIGN.THEME_DETAIL.PREVIEW.ADVANCED_SECTION.DOC_TITLE' | translate"
				[tag]="'DESIGN.THEME_DETAIL.PREVIEW.ADVANCED_SECTION.OPTIONAL' | translate"
				tagStatus="success"
			>
				<p class="preview-text preview-text--secondary">
					{{ 'DESIGN.THEME_DETAIL.PREVIEW.ADVANCED_SECTION.DOC_DESCRIPTION' | translate }}
				</p>
				<tec-alert
					[msg]="'DESIGN.THEME_DETAIL.PREVIEW.ADVANCED_SECTION.DOC_ALERT' | translate"
					[type]="'message'"
					[icon]="'icon-info'"
					hiddenCloseButton
				/>
				<ng-container buttons>
					<tec-button
						[label]="'DESIGN.THEME_DETAIL.PREVIEW.ADVANCED_SECTION.ATTACH' | translate"
					/>
				</ng-container>
			</tec-tile>

			<tec-checkbox
				[formControl]="advancedDeferControl"
				[label]="'DESIGN.THEME_DETAIL.PREVIEW.ADVANCED_SECTION.DEFER' | translate"
			/>
		</div>
	</ng-container>

	@if (themeData?.watermark) {
		<tec-watermark type="default" />
	}
</tec-pwcs-layout>
} @else {
<div class="preview-brand-stack" [class.dark]="isDarkMode">
	<tec-pwcs-layout
		class="preview-brand-card"
		[class.dark]="isDarkMode"
		[title]="'DESIGN.THEME_DETAIL.PREVIEW.TITLE' | translate"
		[subtitle]="'DESIGN.THEME_DETAIL.PREVIEW.SUBTITLE' | translate"
	>
		<tec-topnav
			[img]="previewLogo"
			[title]="themeData?.show_product_name ? 'Identity' : ''"
		>
			<div class="preview-topnav-lang">
				<tec-select [options]="languageOptions" [formControl]="languageControl" />
			</div>
		</tec-topnav>

		<tec-progress [value]="previewProgress" />

		<ng-container content>
			<div class="preview-step">
				<div class="image__wrapper">
					<svg
						class="design-preview-ocr-svg"
						width="88"
						height="62"
						viewBox="0 0 88 62"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
						focusable="false"
					>
						<mask id="design-preview-ocr-mask" fill="white">
							<rect y="0.444336" width="88" height="61.1111" rx="2.44444" />
						</mask>
						<rect
							y="0.444336"
							width="88"
							height="61.1111"
							rx="2.44444"
							stroke="var(--icon-border, #230243)"
							stroke-width="7.33333"
							mask="url(#design-preview-ocr-mask)"
						/>
						<g clip-path="url(#design-preview-ocr-clip)">
							<rect
								x="8.55566"
								y="9"
								width="70.8889"
								height="44"
								rx="2.44444"
								fill="var(--icon-background, #D6DAFF)"
							/>
							<path
								d="M22.7334 41.3818H33.3672C35.5542 41.3819 37.6733 42.5416 39.3105 44.6934C40.9492 46.847 42.0205 49.9106 42.0205 53.3779C42.0204 54.2692 41.7427 55.0052 41.3857 55.4756C41.0305 55.9437 40.6826 56.0615 40.4512 56.0615H15.6494C15.4212 56.0615 15.0726 55.9449 14.7168 55.4785C14.3601 55.0109 14.0801 54.2762 14.0801 53.3779C14.0801 49.9106 15.1514 46.847 16.79 44.6934C18.4272 42.5416 20.5464 41.382 22.7334 41.3818Z"
								stroke="var(--icon-border, #230243)"
								stroke-width="3.95994"
							/>
							<path
								d="M28.0518 20.2568C32.2929 20.2571 35.6414 23.5925 35.6416 27.5967C35.6416 31.6011 32.2931 34.9363 28.0518 34.9365C23.8102 34.9365 20.4609 31.6013 20.4609 27.5967C20.4612 23.5923 23.8104 20.2568 28.0518 20.2568Z"
								stroke="var(--icon-border, #230243)"
								stroke-width="3.95994"
							/>
						</g>
						<defs>
							<clipPath id="design-preview-ocr-clip">
								<rect x="8.55566" y="9" width="70.8889" height="44" rx="2.44444" fill="white" />
							</clipPath>
						</defs>
					</svg>
				</div>
				<span
					class="stepper-info-item__item__text"
					[innerHTML]="'DESIGN.THEME_DETAIL.PREVIEW.DOCUMENT_CHECK_STEP' | translate"
				></span>
			</div>

			<div class="preview-docs">
				<tec-alert
					[msg]="'DESIGN.THEME_DETAIL.PREVIEW.DOCUMENT_ALERT' | translate"
					[type]="'message'"
					[status]="'warning'"
					[icon]="'icon-info'"
					hiddenCloseButton
				/>

				<div class="collapse-group">
					<tec-collapse
						[title]="'DESIGN.THEME_DETAIL.PREVIEW.COLLAPSE.TITLE' | translate"
						[expanded]="false"
						secondary
					>
						<div class="preview-collapse-body">
							<p class="preview-text preview-text--strong">
								{{ 'DESIGN.THEME_DETAIL.PREVIEW.COLLAPSE.DESCRIPTION' | translate }}
							</p>
							<ul>
								<li>
									<span class="preview-text preview-text--strong">
										{{ 'DESIGN.THEME_DETAIL.PREVIEW.COLLAPSE.DOCUMENT_TYPE.DNI' | translate }}
									</span>
								</li>
								<li>
									<span class="preview-text preview-text--strong">
										{{ 'DESIGN.THEME_DETAIL.PREVIEW.COLLAPSE.DOCUMENT_TYPE.NIE' | translate }}
									</span>
								</li>
								<li>
									<span class="preview-text preview-text--strong">
										{{ 'DESIGN.THEME_DETAIL.PREVIEW.COLLAPSE.DOCUMENT_TYPE.PASSPORT' | translate }}
									</span>
								</li>
							</ul>
						</div>
					</tec-collapse>

					<tec-collapse
						[title]="'DESIGN.THEME_DETAIL.PREVIEW.COLLAPSE.DOCS_TITLE' | translate"
						[expanded]="false"
						secondary
					>
						<div class="preview-collapse-body">
							<p class="preview-text preview-text--strong">
								{{ 'DESIGN.THEME_DETAIL.PREVIEW.COLLAPSE.DOCS_DESCRIPTION' | translate }}
							</p>
						</div>
					</tec-collapse>
				</div>
			</div>
		</ng-container>

		<ng-container actions>
			<tec-button
				[label]="'DESIGN.THEME_DETAIL.PREVIEW.BUTTONS.CONTINUE' | translate"
				[size]="'lg'"
			/>
		</ng-container>

		@if (themeData?.watermark) {
			<tec-watermark type="default" />
		}
	</tec-pwcs-layout>

	<tec-pwcs-layout
		class="preview-brand-card"
		[class.dark]="isDarkMode"
		[title]="'DESIGN.THEME_DETAIL.PREVIEW.BRAND_SECTION.TITLE' | translate"
	>
		<tec-progress [value]="previewProgress" />

		<ng-container content>
			<div class="preview-brand-items">
				<tec-item
					[title]="'DESIGN.THEME_DETAIL.PREVIEW.BRAND_SECTION.PENSION_TITLE' | translate"
					[tagImage]="brandBenefitPensionTag"
					[classes]="['preview-brand-item', 'preview-brand-item--info']"
					[selectable]="true"
					[selected]="true"
				>
					<tec-list-detail>
						<span>{{ 'DESIGN.THEME_DETAIL.PREVIEW.BRAND_SECTION.PENSION_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
				</tec-item>

				<tec-item
					[title]="'DESIGN.THEME_DETAIL.PREVIEW.BRAND_SECTION.HEALTH_TITLE' | translate"
					[tagImage]="brandBenefitHealthTag"
					[classes]="['preview-brand-item', 'preview-brand-item--success']"
					[selectable]="true"
				>
					<tec-tag
						[label]="'DESIGN.THEME_DETAIL.PREVIEW.BRAND_SECTION.HEALTH_TAG' | translate"
						status="success"
					/>
					<tec-list-detail>
						<span>{{ 'DESIGN.THEME_DETAIL.PREVIEW.BRAND_SECTION.HEALTH_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
				</tec-item>

				<tec-item
					[title]="'DESIGN.THEME_DETAIL.PREVIEW.BRAND_SECTION.FISCAL_TITLE' | translate"
					[tagImage]="brandBenefitFiscalTag"
					[classes]="['preview-brand-item', 'preview-brand-item--info']"
					[selectable]="true"
				>
					<tec-tag [label]="'DESIGN.THEME_DETAIL.PREVIEW.BRAND_SECTION.FISCAL_TAG' | translate" />
					<tec-list-detail>
						<span>{{ 'DESIGN.THEME_DETAIL.PREVIEW.BRAND_SECTION.FISCAL_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
				</tec-item>
			</div>
		</ng-container>

		<ng-container actions>
			<tec-button
				type="secondary"
				[label]="'DESIGN.THEME_DETAIL.PREVIEW.BUTTONS.CONTINUE' | translate"
				[size]="'lg'"
			/>
		</ng-container>
	</tec-pwcs-layout>
</div>
}
